import React from 'react'
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  FormHelperText,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { TrashIcon } from '../../icons'
import ValidationErrorText from '../common/ValidationErrorText'

const ReasonsToChooseUs = ({ label, placeholder, value = [], onChange, readOnly = false,fieldErrors,fieldType,fieldError }) => {
  // Ensure always at least one item
  // const fields = value.length > 0 ? value : ['']
  const fields = value || ['']

  const handleChange = (index) => (e) => {
    if (readOnly) return
    const newFields = [...fields]
    newFields[index] = e.target.value
    onChange(newFields)
  }

  const handleDelete = (index) => () => {
    if (readOnly) return
    const filtered = fields.filter((_, i) => i !== index)
    // onChange(filtered.length > 0 ? filtered : [''])
    onChange(filtered)
  }

  const handleAddMore = () => {
    if (readOnly) return
    onChange([...fields, ''])
  }

  return (
    <Box>
      <Typography fontSize="14px" fontWeight="500" mb={1}>
        {label}
      </Typography>
          <ValidationErrorText error={fieldError}/>
      {fields.map((fieldValue, index) => (
        <Box
          key={index}
          sx={{ mb: 1, gap: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}
        >
          {/* Counter */}
          <Box>
            <Typography>{index + 1}.</Typography>
          </Box>

          {/* Input */}
          <Box sx={{ width: '100%' }}>
            <TextField
              fullWidth
              placeholder={`${placeholder} ${index + 1}`}
              value={fieldValue}
              onChange={handleChange(index)}
              size="small"
              InputProps={{ readOnly }}
              disabled={readOnly}
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '13px',
                  height: 38,
                  padding: '0 14px',
                  boxSizing: 'border-box',
                },
              }}
            />
          <ValidationErrorText error={fieldErrors?.[`${fieldType}[${index}]`]}/>
          </Box>

          {/* Delete button */}
          <Box>
            {!readOnly && (
              <IconButton
                onClick={handleDelete(index)}
                disabled={value?.length===0 && fields.length === 1}
                aria-label={`Delete Description ${index + 1}`}
              >
                <TrashIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      ))}

      {!readOnly && (
        <Button
          sx={{
            color: '#1075FF',
            border: '1px solid #1075FF',
            textTransform: 'capitalize',
            px: 3,
            mt: 1,
          }}
          onClick={handleAddMore}
          startIcon={<AddIcon />}
        >
          Add More
        </Button>
      )}
    </Box>
  )
}

export default ReasonsToChooseUs
